import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "departmentView__content" }
const _hoisted_3 = { class: "departmentView__leftSide" }
const _hoisted_4 = { class: "departmentView__rightSide" }
const _hoisted_5 = { class: "fl-left" }
const _hoisted_6 = { class: "fl-right" }
const _hoisted_7 = { class: "fl-row" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 1,
  href: "javascript:;",
  disabled: ""
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "separator" }, null, -1)
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "separator" }, null, -1)
const _hoisted_13 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_department_menu_new = _resolveComponent("department-menu-new")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_tree_select = _resolveComponent("a-tree-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_app_table = _resolveComponent("app-table")!
  const _component_action_drawer = _resolveComponent("action-drawer")!
  const _component_del_modal = _resolveComponent("del-modal")!
  const _component_quota_adjustment = _resolveComponent("quota-adjustment")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { class: "utils__pageContainer departmentView" }, {
    title: _withCtx(() => [
      _createElementVNode("div", {
        innerHTML: _ctx.sldPageTitle('#1890ff', '组织架构')
      }, null, 8, _hoisted_1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_department_menu_new, {
            ref: "departmentMenuRef",
            onChangeDepartment: _ctx.onChangeDepartment,
            onChangeCompany: _ctx.onChangeCompany
          }, null, 8, ["onChangeDepartment", "onChangeCompany"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_a_form, {
            class: "fl-clean departmentView__filterForm",
            form: _ctx.filterParams,
            layout: 'inline'
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_a_form_item, { class: "departmentView__controls" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.doWith('create')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("新增部门")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_a_form_item, { label: "部门" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_tree_select, {
                      value: _ctx.filterParams.searchDepartmentId,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterParams.searchDepartmentId) = $event)),
                      style: {"width":"180px"},
                      "allow-clear": "",
                      "show-search": "",
                      placeholder: "部门名称",
                      "search-placeholder": "请选择",
                      "show-line": true,
                      "tree-node-filter-prop": "title",
                      "tree-data": _ctx.departmentList
                    }, null, 8, ["value", "tree-data"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["form"]),
          _createVNode(_component_app_table, {
            ref: "tableRef",
            size: "default",
            "row-key": "id",
            "show-pagination": true,
            columns: _ctx.tableColumns,
            data: _ctx.loadTableData,
            scroll: { x: true }
          }, {
            available: _withCtx(({ record }) => [
              _createTextVNode(_toDisplayString(_ctx.formatWithIntl((record.normalBalance + record.periodBalance) / 100)), 1)
            ]),
            distribution: _withCtx(({ record }) => [
              _createTextVNode(_toDisplayString(_ctx.formatWithIntl((record.normalBalance + record.periodRuleBalance) / 100)), 1)
            ]),
            switch: _withCtx(({ record }) => [
              _createVNode(_component_a_switch, {
                checked: record.isQuota,
                "onUpdate:checked": ($event: any) => ((record.isQuota) = $event),
                loading: record.loading,
                onChange: ($event: any) => (_ctx.quotaSupportedChange($event, record))
              }, null, 8, ["checked", "onUpdate:checked", "loading", "onChange"])
            ]),
            action: _withCtx(({ record }) => [
              _createElementVNode("span", _hoisted_7, [
                (record.quotaSupported)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: "javascript:;",
                      onClick: _withModifiers(($event: any) => (_ctx.onQuotaAdjust(record)), ["prevent"])
                    }, "部门额度管理", 8, _hoisted_8))
                  : (_openBlock(), _createElementBlock("a", _hoisted_9, "部门额度管理")),
                _hoisted_10,
                _createElementVNode("a", {
                  href: "#",
                  onClick: _withModifiers(($event: any) => (_ctx.doWith('view', record.id)), ["prevent"])
                }, "详情", 8, _hoisted_11),
                (record.defaultFlag)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _hoisted_12,
                      _createElementVNode("a", {
                        href: "#",
                        class: "text-error",
                        onClick: _withModifiers(($event: any) => (_ctx.onDelItem(record.id)), ["prevent"])
                      }, "删除", 8, _hoisted_13)
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["columns", "data"])
        ])
      ]),
      _createVNode(_component_action_drawer, {
        ref: "actionDrawerRef",
        onComplete: _ctx.onActionComplete
      }, null, 8, ["onComplete"]),
      _createVNode(_component_del_modal, {
        ref: "delRef",
        onConfirm: _ctx.onDelComplete
      }, null, 8, ["onConfirm"]),
      _createVNode(_component_quota_adjustment, {
        ref: "quotaAdjustRef",
        onComplete: _ctx.onRefreshTable
      }, null, 8, ["onComplete"])
    ]),
    _: 1
  }))
}